const routes = {
  auction: '/auction',
  auctionId: (id: string): string => `${routes.auction}/${id}`,
  creation: '/creation',
  user: '/user',
}

export default routes
